import script from "./CartSummary.vue?vue&type=script&lang=ts&setup=true"
export * from "./CartSummary.vue?vue&type=script&lang=ts&setup=true"

import "./CartSummary.vue?vue&type=style&index=0&id=30bc05ca&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30bc05ca"]])

export default __exports__